(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mobile-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      const menu = root.querySelector?.('#header-mobile-menu');
      if (!menu || menu.dataset.oeMenuReady === 'true') return;

      menu.dataset.oeMenuReady = 'true';

      menu.querySelector('[data-oe-mobile-close]')?.addEventListener('click', () => {
        document.querySelector('[data-toggle="header-mobile-menu"][aria-expanded="true"]')?.click();
      });

      const tabs = [...menu.querySelectorAll('[data-oe-bella-tab]')];
      const panels = [...menu.querySelectorAll('[data-oe-bella-panel]')];

      const selectTab = (nextTab, focus = false) => {
        tabs.forEach((tab) => {
          const selected = tab === nextTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
        });

        if (focus) nextTab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          selectTab(tabs[nextIndex], true);
        });
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
